module.exports = __webpack_public_path__ + "img/Multiple.2fd4fc22.png";